export const SectionsEndpoints = {
  sections: (membershipId: string) =>
    `/rest/public/v2/memberships/${membershipId}/personalization/sections`,
  sectionsItems: (membershipId: string, sectionId: string) =>
    `/rest/public/v1/memberships/${membershipId}/personalization/sections/${sectionId}/items`,
  sectionProductDetail: (membershipSlug: string, productId: string) =>
    `/rest/public/v2/memberships/${membershipSlug}/products/${productId}`
}
